import React from "react"
import { Speaker } from "sharedTypes"
import {
  Avatar,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react"

export type Props = Speaker

const SpeakerDisplay = ({
  photoUrl,
  name,
  title,
  company,
}: Props) => {
  const subtitle = [title, company].filter(Boolean).join(", ")
  return (
    <Flex align="center" gap={0}>
      <Avatar
        size="md"
        mr={5}
        flexShrink={0}
        src={photoUrl}
        name={name}
      />
      <Box flex={1} minW={0}>
        <Text fontSize="md" fontWeight="bold">
          {name}
        </Text>
        {subtitle && (
          <Text fontSize="md">
            {subtitle}
          </Text>
        )}
      </Box>
    </Flex>
  )
}

export default SpeakerDisplay
